import { motion } from 'framer-motion';
import { Globe, Settings as SettingsIcon, ShieldCheck, ShieldOff, ShieldAlert } from 'lucide-react';
import { useUserData, useSubscription } from '../hooks/useApi';
import { AppLang } from '../i18n';
import { SubscriptionPage } from './SubscriptionPage';
import './HomePage.css';

interface HomePageProps {
  user: any;
  lang: AppLang;
  subPage: string | null;
  onNavigate: (page: string) => void;
  onBack: () => void;
  onTabChange: (tab: any) => void;
}

export const HomePage = ({ lang, subPage, onNavigate, onBack, onTabChange }: HomePageProps) => {
  const { data: userData } = useUserData();
  const { data: subData } = useSubscription();

  if (subPage === 'subscription') {
    return <SubscriptionPage lang={lang} onBack={onBack} />;
  }

  const isActive = subData?.status === 'active';
  const isGrace = userData?.subscription?.is_active && (userData?.subscription?.data_limit_bytes ?? 0) > 0;
  const status: 'active' | 'grace' | 'expired' = isGrace ? 'grace' : isActive ? 'active' : 'expired';

  const daysAvailable = userData?.days_left ?? 0;
  const endDate = new Date();
  endDate.setDate(endDate.getDate() + daysAvailable);
  const endDateStr = endDate.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' });

  const statusLabel = status === 'active' ? 'online' : status === 'grace' ? 'ограничена' : 'offline';
  const badgeLabel = status === 'active' ? 'подписка активна' : status === 'grace' ? 'ограниченный доступ' : 'подписка истекла';

  return (
    <div className="hp">
      <motion.div
        className={`hp-hero hp-hero--${status}`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <div className="hp-brand-wrap">
            <motion.img
              src="/logo-full.png?v=3"
              alt="PATRiK VPN"
              className="hp-brand"
              initial={{ opacity: 0, scale: 0.92, y: 8 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              transition={{ duration: 0.55, ease: [0.4, 0, 0.2, 1] }}
            />
          </div>
          <div className="hp-status-row">
            <div className="hp-status-info">
              <span className="hp-date">до {endDateStr}</span>
              <span className={`hp-online hp-online--${status}`}>{statusLabel}</span>
            </div>
            <span className={`hp-badge hp-badge--${status}`}>{badgeLabel}</span>
        </div>

        <div className="hp-actions">
          <button className="hp-btn hp-btn--primary" onClick={() => onNavigate('subscription')}>
            <Globe size={20} />
            <span>{status === 'expired' ? 'Купить подписку' : 'Продлить подписку'}</span>
            
          </button>
          <button className="hp-btn hp-btn--secondary" onClick={() => onTabChange('setup')}>
            <SettingsIcon size={20} />
            <span>Установка и настройка</span>
          </button>
        </div>
      </motion.div>
    </div>
  );
};
